import React, { useEffect } from 'react';
import "../../styles/Services.css";
import GetInTouch from '../../components/GetInTouch';
const webIcon = "/assets/icons/web icon.png";
const mobileicon = "/assets/icons/mobile icon.png";
const ecomicon = "/assets/icons/e-com icon.png";
const crmicon = "/assets/icons/crm.png";
const fintechicon = "/assets/icons/fintech.png";
const saasicon = "/assets/icons/saas.png";



const ApplicationDevelopment = () => {

  useEffect(() => {
    document.title = 'Application development  | Inypeople';
  }, []);
  return (
    <>
      <section className="web-dev-section">
        <div className="web-dev-container">
          <h1 className="web-dev-title">Application Development</h1>

          <p className="web-dev-description">
            Inypeople, a micro-sector specialist, harnesses the full potential of the world’s most popular digital platforms to build powerful, scalable applications. Our niche-focused approach ensures every application functions flawlessly, stands out in a competitive marketplace, and delivers seamless, high-impact user experiences.
          </p>

          <p className="web-dev-subtitle">
            We combine innovation and precision to help businesses stand out in the digital landscape.
          </p>
        </div>

        <div className="circle circle-left"></div>
        <div className="circle circle-right"></div>
        <div className="circle circle-right-top"></div>
        <div className="circle circle-left-bottom"></div>
      </section>

      <section className="services-section">
        <div className="services-container">
          <h2 className="services-main-title">Building apps that accelerate your business growth.</h2>

          <div className="services-grid">
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={webIcon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">Web Application Development</h3>
                </div>

                <p className="service-description">
                  Secure, scalable, and high-performance web applications tailored to your business workflows. Built to adapt, integrate, and grow with your organization.
                </p>
              </div>
            </div>

            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={mobileicon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title">Mobile Application Development</h3>
                </div>
                <p className="service-description">
                  Intuitive, feature-rich mobile apps designed for performance and usability. Engineered to deliver seamless experiences and long-term scalability.
                </p>
              </div>
            </div>
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={ecomicon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title3">E-commerce Applications</h3>
                </div>
                <p className="service-description">
                  End-to-end SaaS solutions from concept to launch and scale. Built for performance, flexibility, and sustainable growth.
                </p>
              </div>
            </div>
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={crmicon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title4">CRM & ERP Solutions</h3>
                </div>
                <p className="service-description">
                  Custom-built systems that streamline operations and enhance productivity. Empower data-driven decisions with centralized, intelligent platforms.
                </p>
              </div>
            </div>
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={fintechicon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title5">FinTech Applications</h3>
                </div>
                <p className="service-description">
                  Secure, compliant, and scalable financial technology solutions. Designed to meet regulatory standards while delivering trust and efficiency.
                </p>
              </div>
            </div>
            <div className="service-card-wrapper">
              <div className="service-card">
                <div className="service-header">
                  <div className="service-icon">
                    <img
                      src={saasicon}
                      alt="Web Development Icon"
                      className="service-icon-img"
                    />
                  </div>

                  <h3 className="service-title6">SaaS Product Development</h3>
                </div>
                <p className="service-description">
                  End-to-end support including system integrations, smooth platform migrations, performance optimization, and ongoing maintenance to keep your website running flawlessly.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Add GetInTouch at the bottom of this service page */}
      <GetInTouch />
    </>
  );
};

export default ApplicationDevelopment;
